// extracted by mini-css-extract-plugin
export default {"inputField":"ypfKBxF65IbSelgDmmzE","checkboxInput":"GdJWjYWHpzNu0xPrta_g","checkboxLabel":"Kkl3wy40dFuMbc6bfxGa","comboboxOption":"pv9s6qYQUxXVT9tUAXDL"};